// Default column definitions for new stories
export const getDefaultColumns = (storyId) => [
  { title: "TO DO", story_id: storyId },
  { title: "IN PROGRESS", story_id: storyId, in_progress: true },
  { title: "REVIEW", story_id: storyId },
  { title: "DONE", story_id: storyId },
];

// Column order for new stories
export const getDefaultColumnOrder = (columns) => {
  return columns.map(col => col.id);
};
